import { Button, Modal } from 'antd';
import { CompassOutlined } from '@ant-design/icons';
import React, { useState } from 'react';
import { ItensTracking } from './Localizacoes';
import TitlePage from 'components/TitlePage';

const App: React.FC<{ record: any }> = ({ record }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  return (
    <>
      <Button
        type="default"
        onClick={() => setIsModalOpen(true)}
        icon={<CompassOutlined />}
        style={{ width: '100%' }}
      >
        Ver localização
      </Button>

      <Modal
        title={<TitlePage>Histórico de localização do CT-e {record?.cteNunota}</TitlePage>}
        visible={isModalOpen}
        footer={[]}
        onCancel={() => setIsModalOpen(false)}
        width={1200}
      >
        <ItensTracking record={record} />
      </Modal>
    </>
  );
};

export default App;
